import { StyledProps } from '@front10';
import React from 'react';
import { isNilOrEmpty } from '../../../../helpers/utils';
import Box from '../../../elements/Box';
import TelephoneNumber from './TelephoneNumber';
import Title from './Title';

type PhoneNumberTypes =
  | 'phoneNumberMain'
  | 'phoneNumberTickets'
  | 'phoneNumberBaggage'
  | 'phoneNumberCustomerService'
  | 'phoneNumberPackageExpress';

interface Props {
  showTitle?: boolean;
  showTelephoneNumbers?: boolean;
  phoneFilters?: PhoneNumberTypes[];
  phoneNumbers?: Record<PhoneNumberTypes, string>;
  titleStyles?: React.ComponentPropsWithoutRef<typeof Title>;
  phoneNumberStyles?: React.ComponentPropsWithoutRef<typeof TelephoneNumber>;
}

function TelephoneNumbers({
  showTitle = true,
  showTelephoneNumbers = true,
  phoneFilters,
  phoneNumbers = {
    phoneNumberMain: '',
    phoneNumberTickets: '',
    phoneNumberBaggage: '',
    phoneNumberCustomerService: '',
    phoneNumberPackageExpress: '',
  },
  titleStyles,
  phoneNumberStyles,
  ...props
}: StyledProps<Props>) {
  const keys = phoneFilters ?? (Object.keys(phoneNumbers) as PhoneNumberTypes[]);
  const phoneItems = keys
    .filter((key) => !isNilOrEmpty(phoneNumbers[key]))
    .map((key) => (
      <TelephoneNumber
        key={key}
        marginTop="1"
        marginBottom="1"
        {...phoneNumberStyles}
        phoneNumberLabelKey={`cmp-bus-directory-map-${key}`}
        phoneNumber={phoneNumbers[key]}
      />
    ));

  return phoneItems.length > 0 ? (
    <Box
      dataTestId="telephoneNumbersLayoutRow"
      display="flex"
      flexDirection="column"
      borderTop={true}
      paddingTop="2"
      paddingBottom="2"
      className="station-item-telephone-numbers"
      {...props}
    >
      {showTitle && (
        <Title
          marginBottom="1"
          leftIcon="phone"
          labelKey="cmp-bus-directory-map-contact-information"
          {...titleStyles}
        />
      )}
      {showTelephoneNumbers && phoneItems}
    </Box>
  ) : null;
}

TelephoneNumbers.componentName = 'TelephoneNumbers';

export default TelephoneNumbers;
